import { render, staticRenderFns } from "./AddFrprint.vue?vue&type=template&id=2fbbfbe8&scoped=true&"
import script from "./AddFrprint.vue?vue&type=script&lang=js&"
export * from "./AddFrprint.vue?vue&type=script&lang=js&"
import style0 from "./AddFrprint.vue?vue&type=style&index=0&id=2fbbfbe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbbfbe8",
  null
  
)

export default component.exports